import { getDataKeyName } from "../../../utilities/UnitsAndKeys/getDataKeyName";
import { autoFormatValue } from "../../../utilities/UnitsAndKeys/convertUnit";
import { Typography, Box, Select, MenuItem } from "@material-ui/core";
import { defaultSettings } from "./Heatmap";
import { format, addDays } from "date-fns";
import React from "react";
import {
  GradientScaleContainer,
  HeatmapHeaderContent,
  GradientScale,
  HeatmapTitle,
} from "./HeatmapHeader.styles";
import { PaddedFlexBox } from "../../../ui/Flex";
import { HeatmapTooltip } from "../../tooltips/HeatmapTooltip";

export const HeatmapHeader = ({
  dataKey,
  setDataKey,
  startDate,
  endDate,
  minMax,
  colors,
  hideTitle,
  hideDropdown,
  hideGradient,
}) => {
  const [minColor, maxColor] = colors;
  const { availableDataKeys } = defaultSettings;
  const formatDateRange = (startDate, endDate) =>
    `${format(addDays(startDate, 1), "dd MMM yyyy")} to ${format(
      endDate,
      "dd MMM yyyy"
    )}`;

  return (
    <React.Fragment>
      {!hideTitle && (
        <Box
          display="flex"
          alignItems="center"
          color={maxColor}
          marginLeft="1rem"
        >
          <HeatmapTitle variant="h6" textcolor={maxColor}>
            {getDataKeyName(dataKey)}
          </HeatmapTitle>
        </Box>
      )}
      <HeatmapHeaderContent>
        <Typography>
          Range displayed: {formatDateRange(startDate, endDate)}
        </Typography>
        <PaddedFlexBox style={{ width: "100%" }} justifycontent="flex-end">
          {!hideDropdown && (
            <Box width="30%">
              <Select
                color="primary"
                style={{ width: "100%", fontSize: "0.875rem" }}
                value={dataKey}
                onChange={(event) =>
                  availableDataKeys.includes(event.target.value) &&
                  setDataKey(event.target.value)
                }
              >
                {availableDataKeys.map((dataKey, index) => (
                  <MenuItem key={index} value={dataKey}>
                    {getDataKeyName(dataKey)}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          )}
          <HeatmapTooltip />
        </PaddedFlexBox>
        {!hideGradient && (
          <GradientScaleContainer
            min={autoFormatValue(minMax.min, dataKey)}
            max={autoFormatValue(minMax.max, dataKey)}
          >
            <GradientScale
              background={`linear-gradient(90deg, ${minColor}, ${maxColor})`}
            />
          </GradientScaleContainer>
        )}
      </HeatmapHeaderContent>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/Heatmap/HeatmapHeader.js